import React, { useState,useEffect  } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import { Img, StyledBox } from "./style";
import { Link, useNavigate } from "react-router-dom";
// import Languages from "./components/Languages";
import routeNames from "../../constants/routeNames";
import { useSelector } from "react-redux";
import { dispatch } from "../../redux";
import { EProtocol, HomeIcon, NavoiyUran } from "../../assets/icons";
import Language from "../Language";
import { Notification } from "../";
import { t } from "i18next";

function NewHeader() {
  const navigate = useNavigate();
  const { isLogged, user_role } = useSelector((store) => store.auth);
  const userData = useSelector((store) => store.userData);
  const [menuToggle, setMenuToggle] = useState(false);
  const { lng } = useSelector((store) => store.language);

  const redirect =
    isLogged && user_role === "ROLE_ADMIN"
      ? routeNames.ADMIN
      : routeNames.USER_COMPANIES;

  const handleToggleMenu = () => {
    function addevent (e) {
      const toogle = document.getElementById("dropdown-header");

      if (toogle?.getAttribute("status")==="true"&&(!e.target.getAttribute("id")||e.target.getAttribute("id")&&!e.target.getAttribute("id").includes("dropdown-element"))) {
        setMenuToggle(false);
      }
    }
    if (!menuToggle) {
      document.body.addEventListener('click', addevent );
    }else {
      document.body.removeEventListener('click', addevent );
    }

    setMenuToggle(!menuToggle);


  };



  const onLogoutClick = () => {
    dispatch.auth.logoutAsync();
    navigate(routeNames.LOGIN);
  };
  console.log(userData,"userData")
  return (
    <AppBar position="static" style={{ backgroundColor: "#fff" }}>
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          <Box
            sx={{
              flexGrow: 2,
              display: { xs: "none", md: "flex" },
              padding: "10px 0",
            }}
          >
            <Link to={redirect}>
              <Img src={EProtocol} alt="" />
            </Link>
            <Link to={redirect}>
              <Img src={NavoiyUran} alt="" />
            </Link>
          </Box>
          <Language />
          <Notification />
          <Button onClick={() => navigate(redirect)}>
            <img src={HomeIcon} alt="Notification" />
          </Button>
          <Box sx={{ flexGrow: 0 }} id={"dropdown-element-1"}>
            {isLogged ? (
              <StyledBox position={"relative"} id={"dropdown-element-2"}>
                <Button className="header-button" onClick={handleToggleMenu} id={"dropdown-element-3"}>
                  <Typography variant="p" id={"dropdown-element-4"}>
                    {userData[`fullName_${lng}`]}
                  </Typography>
                  {/* <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" /> */}
                </Button>

                {menuToggle && (
                  <Box position="absolute" className="menu-box" id="dropdown-header" status={menuToggle.toString()} >
                    <div
                      className="menu-item"
                      onClick={() => {
                        navigate(routeNames.PROFILE);
                        handleToggleMenu();
                      }}
                      id={"dropdown-element-6"}
                    >
                      <Typography variant="p" textAlign="center" color="black" id={"dropdown-element-7"}>
                        {t("userProfile")}
                      </Typography>
                    </div>
                    {userData.authorities.includes("ROLE_ADMIN")?<div
                                                                                       className="menu-item"
                                                                                       onClick={() => {
                                                                                         navigate(routeNames.SETTINGS);
                                                                                       }}
                                                                                       id={"dropdown-element-8"}
                                                                                     >
                                                                                       <Typography variant="p" textAlign="center" color="black" id={"dropdown-element-9"}>
                                                                                         {t("settings")}
                                                                                       </Typography>
                                                                                     </div>:""}

                    <div className="menu-item" onClick={onLogoutClick} id={"dropdown-element-10"}>
                      <Typography variant="p" textAlign="center" color="black" id={"dropdown-element-11"}>
                        {t("logout")}
                      </Typography>
                    </div>
                  </Box>
                )}
              </StyledBox>
            ) : (
              <Link to={routeNames.LOGIN} style={{ textDecoration: "none" }}>
                <Button
                  variant="contained"
                  sx={{
                    my: 2,
                    color: "white",
                    display: "block",
                    width: "150px",
                  }}
                >
                  Boshlamoq
                </Button>
              </Link>
            )}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default NewHeader;
